import { Injectable } from '@angular/core';
import {Headers, Http, Response, ResponseContentType} from '@angular/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { constant } from '../../app.constants';
import { ParentService } from '../A2-utils/ParentClass/ParentService';
import {ICountTrips, IDataProviderList, IPayrollsDetail, IProviderList} from '../../core/interfaces/payrolls-detail.interface';
import {IDetailResponse, ITripDetail} from '../../core/interfaces/trip-detail.interface';

@Injectable()
export class PayrollsService extends ParentService {

  private progressObserver: any;
  private progress: any;

  constructor(private _http: Http, private route: Router) {
    super();
    // this.verifyToken(this._http, route);
  }

  /**
   *
   * @param {string} params
   * @param {files} files
   * @return {Observable<any>}
   */
  public makeFileRequest(params: string[], files: File[], importType = "payments"): Observable < any > {

    return Observable.create(observer => {
      this.progressObserver = observer;

      const formData: FormData = new FormData(),
        xhr: XMLHttpRequest = new XMLHttpRequest();

      for (let i = 0; i < files.length; i++) {
        formData.append('uploads[]', files[i], files[i].name);
      }

      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            observer.next(JSON.parse(xhr.response));
            observer.complete();
          } else {
            observer.error(JSON.parse(xhr.response));
            observer.complete();
          }
        }
      };

      xhr.upload.onprogress = (event) => {
        this.progress = Math.round((event.loaded / event.total) * 100);
        this.progressObserver.next(this.progress);
      };

      const url = importType === "payments"? constant.URL_PAYMENT_CONFIRM: constant.URL_PAYMENT_RETURNS;

      xhr.open('POST', url,  true);
      const user = JSON.parse(localStorage.getItem('currentUser'));
      const token = user ? user.token : '';
      xhr.setRequestHeader('Authorization', `Session ${token}`);
      xhr.send(formData);
    });
  }

  /**
   * @name getCallReceived
   * @description
   */
  getCallReceived() {
    return this._http
      .get(constant.URL_DATE_TIME_NOW, this.getHeader())
      .map(resp => resp.json());
  }

  /**
   * @name getPaymentTrips
   * @param data
   */
  public getPaymentTrips(data) {
    const bodyString = JSON.stringify(data);
    return this._http
      .post(constant.URL_GET_PAYMENT_TRIPS, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  /**
   * @name getTripsStatus
   * @description
   */
  public getTripsStatus() {
    return this._http
      .get(constant.URL_GET_PAYMENT_STATUS, this.getHeader())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  /**
   * @name putPayrollPayment
   * @param data
   */
  putPayrollPayment(data) {
    const bodyString = JSON.stringify(data);
    return this._http
      .put(constant.URL_PAYMENT, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  /**
   * @name putRecalcProvamount
   * @param data
   */
  putRecalcProvamount(data) {
    const bodyString = JSON.stringify(data);
    return this._http
      .put(constant.URL_RECALC_PROVIDER_AMOUNT, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  /**
   * @name getAllEFT
   * @description return all ListByElectronicFoundTransfer
   * @returns {Observable<any>}
   */
  getAllEFT(): Observable < any > {
    return this._http
      .get(constant.EFT, this.getHeader())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  /**
   * @name getProvidersByRangeDate
   * @description return the providers by range date
   * @returns {Observable<any>}
   */
  getProvidersByRangeDate(
  startDate: string,
  endDate: string,
  isPrepaid: boolean,
  selectedStatus?: number,
  ondemand?: boolean
): Observable<any> {

  const paymentStatusId = selectedStatus ? selectedStatus : null;

  const ondemandStr =
    ondemand !== null && ondemand !== undefined
      ? `&onDemand=${ondemand}`
      : '';

  return this._http
    .get(
      `${constant.URL_PROV_PAYROLL}/${startDate}/${endDate}?paymentStatusId=${paymentStatusId}&isPrepaid=${isPrepaid}${ondemandStr}`,
      this.getHeader(),
    )
    .map((res: Response) => res.json())
    .catch((error: any) => Observable.throw(error.json()));
}

  /**
   * @name createEobPdf
   * @description return the pdf file
   * @returns {Observable<any>}
   */
  createEobPdf(providerClaimTripId: number): Observable<any> {
    return this._http.get(constant.URL_GET_EOB_PDF + '/' +
        providerClaimTripId, this.getFileHeaders())
      .catch((error: any) => Observable.throw(error));
  }


  /**
   * @name getFileImport
   * @description Retorna los trip del import
   * @returns {Observable<any>}
   * @param fileid = id del file
   */
  getFileImport(fileid: number): Observable<any> {
    return this._http.get(`${constant.URL_IMPORT_PAYOR}${fileid}`, this.getHeader())
      .map((res: Response) => res.json());
  }

  /**
   *@description retorna los trip segun data
   * @param data
   */
  getTripsDetails(data: IPayrollsDetail): Observable<IDetailResponse> {
    const bodyString = JSON.stringify(data);
    return this._http.post(constant.URL_GET_PAYMENT_DETAIL, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }
  /**
   *@description retorna lista de providers segun data
   * @param data
   */
  getProviderList(data: IDataProviderList): Observable<IProviderList[]> {
    const bodyString = JSON.stringify(data);
    return this._http.post(constant.URL_GET_PROVIDERS, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }/**
   *@description retorna cantidad de trips por status
   * @param data
   */
  getCountTrips(data: IPayrollsDetail): Observable<ICountTrips[]> {
    const bodyString = JSON.stringify(data);
    return this._http.post(constant.URL_COUNT_BY_STATUS, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  validateMassiveManifest(tripIds: number[]): Observable<any> {
    return this._http
      .post(constant.URL_VALIDATE_MASSIVE_MANIFEST, tripIds, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  prepaidProcess(tripIds: number[]): Observable<any> {
    return this._http
      .put(constant.URL_PREPAID_PROCESS, tripIds, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/payrolls/payrolls.service.ts